import { SubmitStatus } from "./SubmitStatus";
import { Alert } from "../../../../../../mads";
import { useI18n } from "../../../../../../shared/I18n";

import React from "react";

export function SubmitMessage({ status }: { status: SubmitStatus }) {
  const { gettext, pgettext } = useI18n();
  if (status === SubmitStatus.INACTIVE) {
    return null;
  }

  if (status === SubmitStatus.SUCCESS) {
    return (
      <Alert
        status="success"
        title={pgettext("report job success title", "Job successfully reported")}
        explainerText={pgettext(
          "report job success text",
          "Thank you for helping us identify suspicious behavior on Indeed",
        )}
      />
    );
  }

  return (
    <Alert
      status="critical"
      title={gettext("We couldn't receive your report")}
      explainerText={gettext(
        "Please try submitting it again later, after we solve the technical problem. You can also tweet us @indeedsupport",
      )}
    />
  );
}

export default SubmitMessage;
